<script setup lang="ts">
const props = defineProps<{
  stepOrder: RegisterUserStepId[]
  currentStep: RegisterUserStepId
}>()

const steps = computed(() => props.stepOrder.filter((step): step is RegisterUserHeaderStepId => step in REGISTER_USER_STEP_LABELS))

const currentIndex = computed(() => steps.value.findIndex(it => it === props.currentStep))
</script>

<template>
  <ContentGrid v-if="currentIndex !== -1" class="text-white w-full">
    <div class="full-width-content flex justify-between items-center pb-l">
      <RegisterUserHeaderStep
        v-for="(step, i) in steps"
        :key="step"
        :step-index="i"
        :active-index="currentIndex"
        :step="step"
      />
    </div>
  </ContentGrid>
</template>
